import Vue from 'vue';
import Vuex from 'vuex';

import * as importedActions from './actions/*.js';

import { consoleMessagesLimit } from './config/constants';

Vue.use(Vuex);

let userInStorage = localStorage.getItem('user');

try {
  userInStorage = JSON.parse(userInStorage);
} catch (e) {
  userInStorage = null;
}

const requests = [
  {
    name: 'auth',
    customFunctions: {
      success: (state, { user, token }) => {
        state.token = token;
        state.user = user;
      }
    }
  },
  { name: 'reloadBuilds' },
  { name: 'reloadBuildsForWl' },
  { name: 'updateBuildsStatuses' },

  { name: 'addCombination' },
  { name: 'editCombination' },
  { name: 'deleteCombination' },

  { name: 'addWhitelabel' },
  { name: 'editWhitelabel' },
  { name: 'deleteWhitelabel' },

  { name: 'addPlatform' },
  { name: 'editPlatform' },
  { name: 'deletePlatform' },

  { name: 'addGoalAbtesting' },
  { name: 'editGoalAbtesting' },
  { name: 'deleteGoalAbtesting' },

  { name: 'deleteAchievedGoal' },

  { name: 'editInstallation' },
  { name: 'deleteInstallation' },

  { name: 'deleteBuild' },
  { name: 'deleteAllBuilds' },
  { name: 'deleteBuildsByFilter' },

  { name: 'removeTesterEmail' },
  { name: 'addTesterEmail' },
  { name: 'editTesterEmail' },

  { name: 'removeTesterIP' },
  { name: 'addTesterIP' },
  { name: 'addTesterIPArray' },
  { name: 'editTesterIP' },

  { name: 'removeAppInfo' },
  { name: 'removeAllAppInfo' },

  { name: 'removeUserFromAbTesting' },

  { name: 'addUser' },
  { name: 'updateUser' },
  { name: 'removeUser' },

  { name: 'removeAppVersionOnTest' },
  { name: 'addAppVersionOnTest' },
  { name: 'editAppVersionOnTest' },

  { name: 'removeWlConfig' },
  { name: 'addWlConfig' },
  { name: 'editWlConfig' },
  { name: 'changeWlConfigIsActive' },

  { name: 'removeAbTesting' },
  { name: 'addAbTesting' },
  { name: 'editAbTesting' },
  { name: 'changeAbTestingIsActive' },

  { name: 'removeLocalisation' },
  { name: 'addLocalisation' },
  { name: 'editLocalisation' },
  { name: 'changeIsActive' },

  { name: 'addTechSupport' },
  { name: 'updateTechSupport' },
  { name: 'removeTechSupport' },

  { name: 'addTestersPhones' },
  { name: 'editTestersPhones' },
  { name: 'removeTestersPhones' },

  { name: 'updateOfficeIp' },
  { name: 'runPipeline' },
  { name: 'insertPipelines' },
  { name: 'deletePipeline' }

  //_INSERT_REQUESTS
];

const getMutationsForRequests = requestsNames =>
  requestsNames
    .map(({ name, customFunctions = {} }) => ({
      [`${name}RequestPending`]: (state, ...params) => {
        state.requests[name].status = 'pending';
        if (typeof customFunctions.pending === 'function')
          customFunctions.pending(state, ...params);
      },
      [`${name}RequestSuccess`]: (state, ...params) => {
        state.requests[name].status = 'success';
        Vue.notify({
          group: 'main',
          title: `${name} request status`,
          text: 'Success',
          type: 'success'
        });
        if (typeof customFunctions.success === 'function')
          customFunctions.success(state, ...params);
      },
      [`${name}RequestError`]: (state, ...params) => {
        state.requests[name].status = 'error';
        Vue.notify({
          group: 'main',
          title: `${name} request status`,
          text: `Error ${params[0]?.response?.data?.message}`,
          type: 'error'
        });
        state.requests[name].errorText =
          params[0]?.response?.data?.message || 'Network Error';
        if (typeof customFunctions.error === 'function')
          customFunctions.error(state, ...params);
      }
    }))
    .reduce((acc, current) => ({ ...acc, ...current }), {});

const getStateForRequests = requestsNames =>
  requestsNames
    .map(({ name }) => ({
      [`${name}`]: { status: '', errorText: '' }
    }))
    .reduce((acc, current) => ({ ...acc, ...current }), {});

export default new Vuex.Store({
  state: {
    requests: {
      ...getStateForRequests(requests)
    },
    token: localStorage.getItem('token') || '',
    user: userInStorage || {},
    ws: {
      console: [],
      buildsStatuses: {},
      buildsErrors: [],
      wlStatuses: {}
    },
    combinations: [],
    whitelabels: [],
    versions: [],
    platforms: [],
    builds: [],
    users: [],
    installations: [],
    localisations: [],
    wlConfig: [],
    testerEmails: [],
    testersPhones: [],
    testerIP: [],
    goalsAbtesting: [],
    abTesting: [],
    achievedGoals: [],
    usersForAbTesting: [],
    appInfo: [],
    appVersionsOnTest: [],
    usersLogs: {},
    techSupport: [],
    pipelines: [],
    officeIp: null

    //_INSERT_STATE
  },
  mutations: {
    ...getMutationsForRequests(requests),
    logout(state) {
      state.token = '';
      state.user = {};
    },
    insertWSconsoleMessages(state, data) {
      state.ws.console.push(data.data);
      if (state.ws.console.length > consoleMessagesLimit) {
        state.ws.console.shift();
      }
    },
    insertWSbuildsErrorsMessages(state, data) {
      state.ws.buildsErrors = data.data || [];
    },
    insertWSbuildsStatusesMessages(state, data) {
      state.ws.buildsStatuses = data.data || {};
    },
    insertWSwlStatusesMessages(state, data) {
      state.ws.wlStatuses = data.data || {};
    },
    insertCombinations(state, data) {
      state.combinations = data.data || {};
    },
    insertWhitelabels(state, data) {
      state.whitelabels = data.data || {};
    },
    insertVersions(state, data) {
      state.versions = data.data || {};
    },
    insertPlatforms(state, data) {
      state.platforms = data.data || {};
    },
    insertBuilds(state, data) {
      state.builds = data.data || {};
    },
    insertUsers(state, data) {
      state.users = data.data || {};
    },
    insertAppInfo(state, data) {
      state.appInfo = data.data || {};
    },
    insertInstallations(state, data) {
      state.installations = data.data || {};
    },
    insertTesterEmails(state, data) {
      state.testerEmails = data.data || {};
    },
    insertTesterIP(state, data) {
      state.testerIP = data.data || {};
    },
    insertAppVersionsOnTest(state, data) {
      state.appVersionsOnTest = data.data || {};
    },
    insertLocalisations(state, data) {
      state.localisations = data.data || {};
    },
    insertWlConfig(state, data) {
      state.wlConfig = data.data || {};
    },
    insertAbTesting(state, data) {
      state.abTesting = data.data || {};
    },
    insertAchievedGoals(state, data) {
      state.achievedGoals = data.data || {};
    },
    insertGoalsAbtesting(state, data) {
      state.goalsAbtesting = data.data || {};
    },
    insertUsersForAbTesting(state, data) {
      state.usersForAbTesting = data.data || {};
    },
    insertUsersLogs(state, data) {
      state.usersLogs = data.data || {};
    },
    insertTechSupport(state, data) {
      state.techSupport = data.data || {};
    },
    insertTestersPhones(state, data) {
      state.testersPhones = data.data || {};
    },
    insertOfficeIp(state, data) {
      state.officeIp = data;
    },
    insertPipelines(state, data) {
      state.pipelines = data;
    },
    setAppConfig(state, data) {
      state.appConfig = data;
    }

    //_INSERT_MUTATION
  },
  actions: Object.values(importedActions).reduce(
    (acc, obj) => ({ ...acc, ...obj }),
    {}
  ),
  getters: {
    isLoggedIn: state => !!state.token,
    role: state => state.user.role,
    isRequestPending: state => requestType =>
      state.requests[requestType].status === 'pending'
  }
});
